import React from 'react'
import { styled, keyframes } from '@mui/material/styles'
import { Stack, Card, Avatar, Button, MenuItem, Menu, ListItem } from '@mui/material'
import { MenuPage } from '@/layout/MenuView/components'
import { ImageIcon } from '@/icon'
import { hoverLight, primary, secondaryText } from '@/constant'

import id_icon from '@/asset/img/id_icon.webp'
import org_icon from '@/asset/img/org_icon.webp'
import news_icon from '@/asset/img/news_icon.webp'
import market_icon from '@/asset/img/market_icon.webp'
import activity_icon from '@/asset/img/activity_icon.webp'
import my_products_icon from '@/asset/img/my_products_icon.webp'
import notifications_icon from '@/asset/img/notifications_icon.webp'
import notifications_empty from '@/asset/img/notifications_empty.webp'

export const Main = styled(MenuPage)(() => ({
  display: 'flex',
  gap: '14px',
  '&::webkit-scrollbar': { backgroundColor: 'transparent' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: 'transparent' },
}))

export const FlexRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}))

export const LeftContet = styled(Stack)(() => ({
  padding: '14px 0 0px 14px',
  paddingBottom: '0px',
  position: 'relative',
}))

export const RightContet = styled(Stack)(() => ({
  flex: 1,
  padding: '28px 14px 14px 0',
  paddingBottom: '0px',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  overflow: 'auto',
  height: '100%',
}))

export const ScrollY = styled('div')(() => ({
  height: '100%',
  // overflow: "overlay",
}))

export const InfoWrapper = styled(Card)(() => ({
  display: 'flex',
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
}))

export const InfoTitleRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gridColumn: '1/-1',
}))

export const InfoCardBase = styled(Card)(() => ({
  display: 'flex',
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  flexDirection: 'column',
  boxShadow: 'none',
  padding: '14px 0px 0px 0px',
  width: '280px',
  gap: '8px',
  overflow: 'visible',
  zIndex: 2,
  '& .info_item:hover, & .space_list_btn:hover, & .space_list_btn-active': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '& nav': {
    background: '#fff',
    borderRadius: '4px',
    boxShadow: '0px 4px 10px 0px rgba(145,158,171,0.1)',
    padding: '0 14px',
  },
}))

export const OrgIcon = styled(Avatar)(() => ({
  width: '56px',
  height: '56px',
  fontSize: '32px',
}))

export const OrgId = styled('div')(() => ({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
}))

export const OrgButton = styled(Button)(() => ({
  fontSize: '20px',
  backgroundColor: hoverLight,
  color: primary,
  padding: '4px 24px',
}))

export const OrgListItem = styled(ListItem)(() => ({
  paddingTop: '4px',
  paddingBottom: '4px',
  height: '50px',
  '& .dot_icon': {
    transition: 'all 0.2s ease-in-out',
    borderRadius: '50%',
  },
  '& .space_list_btn-checked ': {
    backgroundColor: hoverLight,
  },
  '& .space_list_btn-checked .MuiListItemText-primary, &:hover .MuiListItemText-primary, & .space_list_btn-active': {
    color: 'rgba(0, 0, 0, 1)',
    fontWeight: '500',
  },
  '& .space_list_btn-active .icon_btn, &:hover .icon_btn, ': {
    opacity: 1,
  },
  '&:hover .icon_btn:hover': {
    color: primary,
  },
  '& .icon_btn': {
    opacity: 0,
  },
}))
export const OrgMenu = styled(Menu)(() => ({
  '& .MuiMenu-paper': {
    borderRadius: '4px',
  },
}))
export const OrgMenuItem = styled(MenuItem)(() => ({
  width: '123px',
  color: 'rgba(0, 0, 0, 1)',
  '&:hover': {
    backgroundColor: hoverLight,
  },
  fontSize: '14px',
}))

export const ActivityCol = styled(Stack)(() => ({
  gap: '32px',
  padding: '20px 0px',
  paddingBottom: '0',
  zIndex: 1,
}))

export const IdIcon = () => <ImageIcon src={id_icon} />
export const TitleIcon = () => <ImageIcon src={org_icon} />
export const NewsIcon = () => <ImageIcon src={news_icon} sx={{ width: '12px' }} />

export const MarketIcon = () => <ImageIcon src={market_icon} sx={{ width: '48px', position: 'relative', top: '8px' }} />
export const ActivityIcon = () => (
  <ImageIcon src={activity_icon} sx={{ width: '48px', position: 'relative', top: '8px' }} />
)
export const ProductsIcon = () => (
  <ImageIcon src={my_products_icon} sx={{ width: '48px', position: 'relative', top: '8px' }} />
)
export const NotificationIcon = () => (
  <ImageIcon src={notifications_icon} sx={{ width: '48px', position: 'relative', top: '8px' }} />
)
export const NotificationEmptyIcon = () => (
  <ImageIcon
    src={notifications_empty}
    sx={{
      width: '64px',
      position: 'relative',
      margin: '32px 40%',
    }}
  />
)

export const ActivityCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'banner',
})<{ banner: string }>(({ banner }) => ({
  padding: '32px',
  display: 'flex',
  gap: '8px',
  flexDirection: 'column',
  boxShadow: 'none',
  backgroundImage: `url(${banner})`,
  backgroundSize: '100%',
  backgroundPositionX: 'right',
  backgroundPositionY: 'center',
  width: '360px',
  cursor: 'pointer',
  height: '150px',
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    boxShadow: '0px 40px 40px 0px rgba(4,27,15,0.1)',
    transform: 'translateY(-10px)',
    backgroundSize: '120%',
    transition: 'all 0.2s ease-in-out',
  },
}))

export const ProductsRow = styled('div')(() => ({
  display: 'grid',
  gap: '24px',
  padding: '0px',
  paddingBottom: '40px',
  gridTemplateColumns: 'repeat(auto-fit, 360px)',
  // justifyContent: "center",
}))

export const MyProductRow = styled('div')(() => ({
  display: 'grid',
  gap: '24px',
  padding: '0px',
  gridTemplateColumns: 'repeat(auto-fit, 224px)',
  justifyContent: 'space-evenly',
}))

export const ProductCard = styled('div')(() => ({
  borderRadius: '4px',
  transition: 'all 0.2s ease-in-out',
  boxShadow: '0px 4px 10px 0px rgba(145,158,171,0.1)',
  '& .drag_handle': {
    transform: 'rotate(270deg)',
    position: 'absolute',
    right: '-2px',
    top: '-5px',
    cursor: 'move',
    visibility: 'hidden',
    width: '16px',
  },
  '&:hover .drag_handle': {
    visibility: 'visible',
  },
  '& > .card-content > .content-footer': {
    '.content-footer-text': {
      opacity: 1,
      transition: 'all 0.2s ease-in-out',
    },
    '.content-footer-arrow-right': {
      transform: 'rotate(180deg)',
      opacity: 1,
      transition: 'all 0.2s ease-in-out',
    },
    '.content-footer-arrow-left': {
      position: 'absolute',
      transform: 'rotate(180deg) translateX(10px)',
      opacity: 0,
      transition: 'all 0.2s ease-in-out',
    },
    '.content-footer-button': {
      opacity: 0,
    },
  },
  // "&:hover": {
  //   boxShadow: "0px 40px 40px 0px rgba(4,27,15,0.1)",
  //   transform: "translateY(-10px)",
  //   transition: "all 0.2s ease-in-out",
  //   "& > .card-content > .content-footer": {
  //     ".content-footer-text": {
  //       opacity: 0,
  //       transition: "all 0.2s ease-in-out",
  //     },
  //     ".content-footer-arrow-left": {
  //       transform: "rotate(180deg) translateX(0px)",
  //       opacity: 1,
  //       transition: "all 0.2s ease-in-out 0.5s",
  //     },
  //     ".content-footer-arrow-right": {
  //       transform: "rotate(180deg) translateX(-10px)",
  //       opacity: 0,
  //       transition: "all 0.2s ease-in-out 0.2s",
  //     },
  //     ".content-footer-button": {
  //       animationName: bounceText,
  //       animationDuration: "0.8s",
  //       animationDelay: "0.2s",
  //       animationFillMode: "forwards",
  //     },
  //   },
  // },
}))

const bounceText = keyframes({
  '0%': {
    left: '50%',
    opacity: 0,
  },
  '55%': {
    opacity: 1,
    left: '76%',
  },
  '70%': {
    opacity: 1,
    left: '73%',
  },
  '80%': {
    opacity: 1,
    left: '75%',
  },
  '90%': {
    opacity: 1,
    left: '74%',
  },
  '100%': {
    opacity: 1,
    left: '75%',
  },
})

export const CardHoverArea = styled('div')({
  flex: '0 0 264px',
  overflow: 'visible',
  '&:hover': {
    '& .product-card': {
      boxShadow: '0px 40px 40px 0px rgba(4,27,15,0.1)',
      transform: 'translateY(-10px)',
      transition: 'all 0.2s ease-in-out',
      '& > .card-content > .content-footer': {
        '.content-footer-text': {
          opacity: 0,
          transition: 'all 0.2s ease-in-out',
        },
        '.content-footer-arrow-left': {
          transform: 'rotate(180deg) translateX(0px)',
          opacity: 1,
          transition: 'all 0.2s ease-in-out 0.5s',
        },
        '.content-footer-arrow-right': {
          transform: 'rotate(180deg) translateX(-10px)',
          opacity: 0,
          transition: 'all 0.2s ease-in-out 0.2s',
        },
        '.content-footer-button': {
          animationName: bounceText,
          animationDuration: '0.8s',
          animationDelay: '0.2s',
          animationFillMode: 'forwards',
        },
      },
    },
  },
})

export const CardContent = styled('div')(() => ({
  flexDirection: 'column',
  display: 'flex',
  padding: '16px 16px 12px 16px',
  borderRadius: '4px 4px 0 0',
  justifyContent: 'space-between',
}))

export const ProductCardContentWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'transformWidth' && prop !== 'transformDirection',
})<{ transformWidth?: number; transformDirection: 'horizontal' | 'vertical' }>(({ transformDirection }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  flexDirection: transformDirection === 'horizontal' ? 'row' : 'column',
  transition: 'all 0.2s ease-in-out',
  '& #product-content-mask': {
    opacity: 0,
    flex: 1,
    transition: 'all 0.2s ease-in-out',
  },
  '& #product-card': {
    position: 'relative',
    paddingBottom: '4px',
    opacity: 0,
    transform: 'translateY(30px)',
    transition: 'all 0.2s ease-in-out',
    '#product-detail #product-icon': {
      transform: 'translateY(10px)',
      opacity: 0,
      transition: 'all 0.2s ease-in-out',
    },
    '#product-detail #product-title': {
      transform: 'translateY(10px)',
      opacity: 0,
      transition: 'all 0.2s ease-in-out',
    },
    '#product-news': {
      display: 'none',
    },
    '#product-desc': {
      transform: 'translateY(10px)',
      opacity: 0,
      transition: 'all 0.2s ease-in-out',
      marginTop: '4px',
    },
    '#product-footer': {
      transform: 'translateX(-20px)',
      opacity: 0,
      transition: 'all 0.2s ease-in-out 0.2s',
      '& .content-footer-arrow-left': {
        transform: 'translateX(-20px) rotate(180deg)',
        opacity: 0,
        transition: 'all 0.2s ease-in-out  0.2s',
      },
    },
  },
  '&:hover': {
    // transform:
    //   transformDirection === "horizontal"
    //     ? `translateX(${transformWidth}px)`
    //     : `translateY(${transformWidth}px)`,
    transition: 'all 0.2s ease-in-out',
    // ...{
    //   "& #product-content-mask": {
    //     opacity: 1,
    //     transition: "all 0.2s ease-in-out 0.1s",
    //   },
    //   "& #product-card": {
    //     transform: "translateY(0px)",
    //     opacity: 1,
    //     transition: "all 0.2s ease-in-out",

    //     "#product-detail #product-icon": {
    //       transform: "translateY(0px)",
    //       opacity: 1,
    //       transition: "all 0.2s ease-in-out 0.1s",
    //     },
    //     "#product-detail #product-title": {
    //       transform: "translateY(0px)",
    //       opacity: 1,
    //       transition: "all 0.2s ease-in-out 0.1s",
    //     },
    //     "#product-news": {
    //       display: "none",
    //     },
    //     "#product-desc": {
    //       transform: "translateY(0px)",
    //       opacity: 1,
    //       transition: "all 0.2s ease-in-out 0.2s",
    //     },
    //     "#product-footer": {
    //       transform: "translateX(0px)",
    //       opacity: 1,
    //       transition: "all 0.2s ease-in-out  0.4s",
    //       "& .content-footer-arrow-left": {
    //         transform: "translateX(0px) rotate(180deg)",
    //         opacity: 1,
    //         transition: "all 0.2s ease-in-out  0.6s",
    //       },
    //     },
    //   },
    // },
  },
}))

export const LargeCardHoverArea = styled('div')({
  overflow: 'visible',
  '& .large-product-cad': {
    border: '1px solid #E5E5E5',
    transform: 'translateY(0px)',
    transition: 'all 0.2s ease-in-out',
  },
  ...{
    '& .large-product-cad #product-content-mask': {
      opacity: 1,
      transition: 'all 0.2s ease-in-out 0.1s',
    },
    '& .large-product-cad #product-card': {
      transform: 'translateY(0px)',
      opacity: 1,
      transition: 'all 0.2s ease-in-out',

      '#product-detail #product-icon': {
        transform: 'translateY(0px)',
        opacity: 1,
        transition: 'all 0.2s ease-in-out 0.1s',
      },
      '#product-detail #product-title': {
        transform: 'translateY(0px)',
        opacity: 1,
        transition: 'all 0.2s ease-in-out 0.1s',
      },
      '#product-news': {
        display: 'none',
      },
      '#product-desc': {
        transform: 'translateY(0px)',
        opacity: 1,
        transition: 'all 0.2s ease-in-out 0.2s',
        lineHeight: '20px',
      },
      '#product-footer': {
        transform: 'translateX(0px)',
        opacity: 1,
        transition: 'all 0.2s ease-in-out  0.4s',
        '& .content-footer-arrow-left': {
          transform: 'translateX(0px) rotate(180deg)',
          opacity: 1,
          transition: 'all 0.2s ease-in-out  0.6s',
        },
      },
    },
  },
})

export const ProductCardLarge = styled('div')(() => ({
  overflow: 'hidden',
  width: '360px',
  height: '178px',
  transition: 'all 0.2s ease-in-out',
  // "&:hover": {
  //   boxShadow: "0px 40px 40px 0px rgba(4,27,15,0.1)",
  //   transform: "translateY(-10px)",
  //   transition: "all 0.2s ease-in-out",
  // },
}))

export const ContentFooter = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  fontSize: '14px',
  color: secondaryText,
}))

export const Tag = styled('div')(() => ({
  display: 'inline-block',
  border: '1px solid #dbdbdb',
  color: '#999999',
  fontSize: '12px',
  padding: '0 4px',
  lineHeight: '20px',
}))

export const RoleTag = styled('div')(() => ({
  display: 'flex',
  backgroundColor: 'transparent',
  alignItems: 'center',
  lineHeight: '24px',
  maxWidth: '162px',
  height: '24px',
  textAlign: 'center',
  borderRadius: '4px',
}))

export const NewsContent = styled('div')(() => ({
  display: 'flex',
  margin: '16px 8px',
  alignItems: 'center',
}))

const scrollingEffect = keyframes({
  from: {
    transform: 'translateX(100%)',
  },
  to: {
    transform: 'translateX(-100%)',
  },
})

export const ScrollingNews = styled('div')(() => ({
  overflow: 'hidden',
  '& #news-text': {
    animation: `${scrollingEffect} 15s linear infinite`,
  },
}))

export const OrgCard = styled(FlexRow)(() => ({
  backgroundColor: 'transparent',
  justifyContent: 'space-between',
  transition: 'all 0.2s ease-in-out',
  padding: '24px',
  paddingRight: '12px',
  '&:hover': {
    backgroundColor: '#FFF',
    transition: 'all 0.2s ease-in-out',
  },
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  alignItems: 'center',
}))

export const Divider = styled('div')(() => ({
  height: '1px',
  flex: 1,
  margin: '0 30px',
  maxWidth: '572px',
  backgroundColor: '#041B0F1A',
}))

export const SortButton = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '4px',
  gap: '8px',
  width: '102px',
  height: '30px',
  cursor: 'pointer',
  backgroundColor: '#F3F4F7',
  '&:hover': {
    backgroundColor: '#eeeeee',
  },
  '&:active': {
    backgroundColor: '#eeeeee',
  },
})
